<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>{{'預り金振替不能登録画面'}}</h1>

<app-sgke080d-result *ngIf="depLstInfo?.length > 0" [responseList]="depLstInfo"
    (onDblClickRowEmitter)="onDblClickRow($event)" (onClickRegistEmitter)="onClickRegist($event)"
    (onClickCancelEmitter)="onClickCancel($event)"></app-sgke080d-result>